exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".ps-company-detail-page{background-color:white;overflow:scroll;height:calc(100vh - 65px);font-family:\"Inter\", sans-serif}.ps-company-detail-page--y-spacer{height:30px}.ps-company-detail-page__lorem-ipsum{color:#d80def}\n", ""]);

// exports
